import {SearchCriteria} from "@core/bean/search-criteria";
import {Sort} from "@core/bean/sort";
import {DataAssign} from "@core/bean/data-asign";
import {PageData} from "@core/bean/page-data";
import {Observable} from "rxjs/index";
import {HttpParams, HttpResponse} from "@angular/common/http";


export abstract class AbstractPagination {


  PARA_NAME_PAGE = 'page';
  PARA_NAME_SIZE = 'size';
  PARA_NAME_SORT = 'sort';
  PARA_NAME_PROPERTYNAMES = 'propertyNames';
  PARA_NAME_PROPERTYVALUES = 'propertyValues';
  PARA_NAME_DATAASSIGNSJSON = 'dataAssignsJson';
  HEADER_NAME_TOTALCOUNT = 'X-Total-Count';


  pageSizeOptions = [10, 20, 50, 100];
  scrollConfig = {};
  expandForm: boolean = false;
  loading: boolean = false;

  page: number = 1;
  size: number = 10;

  sortData: any = {};
  sorts: Sort[] = [];
  defaultSorts: Sort[] = [];

  multipleCheck = true;
  allChecked = false;
  indeterminate = false;
  selectedRows = [];
  selectedLength = {selectedLength: 0};
  searchData: any = {};
  workflowSearchData: any = {};
  searchCriteria: SearchCriteria[] = [];

  dataAssigns: DataAssign[] = [];

  pageData: PageData = new PageData(0, []);

  abstract getOriginalData(params: HttpParams): Observable<HttpResponse<any>>;


  public toFirstPage() {
    this.page = 1;
    this.loadData();
  };

  public addSort(sort: Sort) {
    this.removeSort(sort);
    this.sorts.push(sort);
  }

  public removeSort(sort: Sort) {
    this.removeSortByName(this.sorts, sort.name);
  }

  /**
   * 添加默认排序，即未指定其他排序的情况下时使用的排序。
   * @param sort 排序
   */
  public addDefaultSort(sort: Sort) {
    this.removeDefaultSort(sort);
    this.defaultSorts.push(sort);
  }

  public removeDefaultSort(sort: Sort) {
    this.removeSortByName(this.defaultSorts, sort.name);
  }

  /**
   * 添加初始排序，即初始时的排序状态
   * 此排序需在表格上有对应操作按钮，同时需要用sortData[key]进行双向绑定
   * @param sort 排序
   */
  public addInitSort(sort: Sort) {
    this.addSort(sort);
    this.sortData[sort.name] = sort.getDirectionString();
  }

  public removeSortByName(sorts: Sort[], name: string) {
    let sort = sorts.find(sort => {
      return sort.name === name
    });
    if (sort) {
      let index = sorts.indexOf(sort);
      sorts.splice(index, 1);
    }
  }

  public cleanSorts() {
    this.sorts = [];
  }

  public addDataAssign(dataAssign: DataAssign) {
    this.removeDataAssign(dataAssign);
    this.dataAssigns.push(dataAssign);
  }

  public removeDataAssign(dataAssign: DataAssign) {
    this.removeDataAssignByName(dataAssign.key);
  }

  public removeDataAssignByName(name: string) {
    let dataAssign = this.dataAssigns.find(dataAssign => {
      return dataAssign.key === name
    });
    if (dataAssign) {
      let index = this.dataAssigns.indexOf(dataAssign);
      this.dataAssigns.splice(index, 1);
    }
  }

  public cleanDataAssigns() {
    this.dataAssigns = [];
  }

  public addSearchCriteria(searchCriteria: SearchCriteria) {
    this.removeSearchCriteria(searchCriteria);
    this.searchCriteria.push(searchCriteria);
  }

  public removeSearchCriteria(searchCriteria: SearchCriteria) {
    this.removeSearchCriteriaByName(searchCriteria.name);
  }

  public removeSearchCriteriaByName(name: string) {
    let searchCriteria = this.searchCriteria.find(searchCriteria => {
      return searchCriteria.name === name
    });
    if (searchCriteria) {
      let index = this.searchCriteria.indexOf(searchCriteria);
      this.searchCriteria.splice(index, 1);
    }
  }

  public cleanSearchCriteria() {
    this.searchCriteria = [];
  }


  public getDataAssignsJson(): string {
    return JSON.stringify(this.dataAssigns);
  }


  public loadData() {
    this.loading = true;
    this.getOriginalData(this.getHttpParams()).subscribe((httpResponse: HttpResponse<any>) => {
      let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
      let data = httpResponse.body;
      let pageData = new PageData(Number.parseInt(totalCount), data);
      this.pageData = pageData;
      this.refreshStatus();
      this.loading = false;
    }, error => {
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  private searchDataToSearchCriteria(): SearchCriteria[] {
    let result = [];
    let tempSearchData = this.searchData;
    for (let key in tempSearchData) {
      if (this.searchData[key]||this.searchData[key]=='0') {
        result.push(new SearchCriteria(key, this.searchData[key]));
      }
    }
    return result;
  }

  public getAllSearchCriteria(): SearchCriteria[] {
    return this.searchCriteria.concat(this.searchDataToSearchCriteria());
  }

  public onSizeChange(size) {
    this.loadData()
  }

  public onPageChange(page) {
    this.loadData()
  }

  public onSortChange(sort) {
    if (sort) {
      if (sort.value) {
        this.addSort(Sort.parse(sort.key + ' ' + sort.value));
      } else {
        this.removeSortByName(this.sorts, sort.key);
      }
    }
    this.loadData();
  }

  refreshStatus(): void {
    if (!this.multipleCheck) {
      if (this.selectedRows.length) {
        if (this.selectedRows[0].checked) {
          this.selectedRows[0].checked = false;
        }
      }
    }
    this.selectedRows = this.pageData.data.filter(data => data.checked);
    this.selectedLength = {selectedLength: this.selectedRows.length};
    const allChecked = this.pageData.data.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.pageData.data.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  checkAll(value: boolean): void {
    if (!this.multipleCheck) {
      return;
    }
    this.pageData.data.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  public getSelectedRowsId(): string[] {
    let id = [];
    this.selectedRows.map(row => {
      id.push(row.id);
    });
    return id;
  }


  public getHttpParams(): HttpParams {
    let params = new HttpParams()
      .set(this.PARA_NAME_PAGE, (this.page - 1).toString())//页码
      .set(this.PARA_NAME_SIZE, this.size.toString())//页大小
      .set(this.PARA_NAME_DATAASSIGNSJSON, this.getDataAssignsJson());//数据条件
    params = this.addSortToHttpParams(params);//排序
    params = this.addSearchCriteriaToHttpParams(params);//查询条件
    params = this.addWorkFlowCriteriaToHttpParams(params);//工作流条件
    return params;
  }

  public addSearchCriteriaToHttpParams(httpParams: HttpParams): HttpParams {
    this.getAllSearchCriteria().map(searchCriteria => {
      if (searchCriteria.name && (searchCriteria.value||searchCriteria.value=='0')) {
        httpParams = httpParams.append(this.PARA_NAME_PROPERTYNAMES, searchCriteria.name)
          .append(this.PARA_NAME_PROPERTYVALUES, searchCriteria.value);
      }
    });
    return httpParams;
  }

  public addWorkFlowCriteriaToHttpParams(httpParams: HttpParams): HttpParams {
    let tempWorkflowSearchData = this.workflowSearchData;
    for (let key in tempWorkflowSearchData) {
      if (this.workflowSearchData[key]) {
        httpParams = httpParams.append(key, this.workflowSearchData[key]);
      }
    }
    return httpParams;
  }

  public addSortToHttpParams(httpParams: HttpParams): HttpParams {
    this.sorts.map(sort => {
      httpParams = httpParams.append(this.PARA_NAME_SORT, sort.toString())//排序
    });
    //默认排序，就是没有其他排序的情况下使用的，比如初始的id倒序
    if (this.sorts.length < 1) {
      this.defaultSorts.map(sort => {
        httpParams = httpParams.append(this.PARA_NAME_SORT, sort.toString())//默认排序
      });
    }
    return httpParams;
  }
}
